import {captureMessage, captureException, getClient} from '@sentry/browser';

const sendLogMessage = captureMessage;
const sendException = captureException;

export {sendLogMessage, sendException, getClient};
